export function canDeleteInventoryItem(user) {
  const role = String(user?.role_name || user?.role || "").trim().toLowerCase();
  return role === "owner";
}
